<script setup lang="ts">
import AppIcon from './AppIcon.vue';
import BrandMark from './BrandMark.vue';
import type { IconName } from './icons.js';
/** Centered explanation with an optional action row. Use for empty, signed-out and failed states. */
defineProps<{ title: string; icon?: IconName; brand?: boolean; tone?: 'neutral' | 'danger' }>();
</script>

<template>
  <section class="empty-state panel" :data-tone="tone ?? 'neutral'">
    <span class="empty-state-glyph" aria-hidden="true">
      <BrandMark v-if="brand" />
      <AppIcon v-else :name="icon ?? 'devices'" />
    </span>
    <h2>{{ title }}</h2>
    <p><slot /></p>
    <div v-if="$slots.actions" class="empty-state-actions"><slot name="actions" /></div>
    <p v-if="$slots.hint" class="hint"><slot name="hint" /></p>
  </section>
</template>
